<!-- src/components/DiscardTransactionPopup.vue -->
<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
    <div class="bg-white rounded-lg shadow-lg w-96 p-6">
      <h2 class="text-lg font-semibold mb-4">거래내역 제외</h2>
      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            제외 사유
          </label>
          <textarea v-model="reason" placeholder="제외 사유를 입력하세요"
            class="w-full p-2 border border-gray-300 rounded-md"></textarea>
        </div>
      </div>
      <div class="mt-6 flex justify-end space-x-3">
        <button @click="confirm" class="px-4 py-2 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600"
          :disabled="!reason.trim()">
          확인
        </button>
        <button @click="cancel" class="px-4 py-2 bg-gray-200 text-gray-700 text-sm rounded-md hover:bg-gray-300">
          취소
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import transactionService from '@/service/transactionService';

export default {
  name: 'DiscardTransactionPopup',
  props: {
    transactionId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      reason: '',
    };
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    async confirm() {
      if (!this.reason.trim()) {
        alert('제외 사유를 입력해주세요.');
        return;
      }
      try {
        await transactionService.discardTransaction(this.transactionId, this.reason);
        alert('거래내역이 제외되었습니다.');
        this.$emit('close', true);
      } catch (error) {
        console.error('거래내역 제외 중 오류 발생:', error);
        alert('거래내역 제외에 실패했습니다. 다시 시도해주세요.');
      }
    },
  },
};
</script>

<style scoped>
.btn-base {
  @apply px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700;
}
</style>
